















import Vue from "vue";

export default Vue.extend({
  name: "RangeSlider",

  model: {
    prop: "modelValue",
    event: "change"
  },

  props: {
    label: {
      type: String,
      required: false
    },

    modelValue: {
      type: Number
    },

    max: {
      type: Number,
      required: false,
      default: 1000
    }
  },

  data: () => {
    return {
      id: ""
    };
  },

  computed: {
    inputValue: {
      get(): number {
        return this.modelValue;
      },

      set(value: string): void {
        this.$emit("change", parseInt(value));
      }
    }
  },

  created(): void {
    this.id = `form-group-${this._uid}`;
  }
});
